interface IProcessedUsersAndDevices {
  users: any;
  devices: any;
}

export const appChanged = async (app: string): Promise<IProcessedUsersAndDevices> => {
  const ret: IProcessedUsersAndDevices = {
    users: [],
    devices: []
  };
  // try {
  //   const userResult = await UserAPI.getUsersForApp(app);
  //   const devicesResult = await DevicesAPI.getDevicesByBrandAndType(app, "all");
  //   for (let i = 0; i < userResult.body.data.length; i++) {
  //     const user = userResult.body.data[i];
  //     userIdMapping[user.id] = user;
  //     userIdMapping[user.id].devices = [];
  //     userIdMapping[user.id].devicesCount = 0;
  //     userIdMapping[user.id].index = i;
  //     userResult.body.data[i].devices = [];
  //   }

  //   // now loop over the devices
  //   for (const device of devicesResult.body.data) {
  //     const uId = device.registeredBy;
  //     if (userIdMapping.hasOwnProperty(uId)) {
  //       if (device.brand === "") {
  //         device.brand = device.service === "wagz2" ? "wagz" : device.service;
  //       }
  //       userIdMapping[uId].devices.push(device);
  //       device.registeredByInfo = {
  //         firstName: userIdMapping[uId].firstName,
  //         lastName: userIdMapping[uId].lastName,
  //         email: userIdMapping[uId].email,
  //       };
  //       userResult.body.data[userIdMapping[uId].index].devices.push(device);
  //       userResult.body.data[userIdMapping[uId].index].devicesCount += 1;
  //     }
  //   }

  //   ret.users = userResult.body.data;
  //   ret.devices = devicesResult.body.data;
  // } catch (err) {
  //   Promise.reject(err);
  // }
  return ret;
};


// WEBPACK FOOTER //
// ./src/utils/changeHelpers.ts